import { TreeNode } from "@/types/tree";
import {
  setImageControlsInSectionToStockPhotoSearchResults,
  setStockPhotoSearchKeywordsForImageControlsInASection,
  setStockPhotoSearchResultsForImageControlsInASection
} from "./images";

export async function replaceImagesInSectionWithAi(
  section: TreeNode,
  _abortController: AbortController
) {
  console.log("replaceImagesInSectionWithAi starting...", section.id);

  await setStockPhotoSearchKeywordsForImageControlsInASection(section, "store");
  await setStockPhotoSearchResultsForImageControlsInASection(section, "store");
  await setImageControlsInSectionToStockPhotoSearchResults(section, "store");

  console.log("replaceImagesInSectionWithAi done for", section.id);
}

export async function replaceImagesInSectionWithAiMutating(
  section: TreeNode,
  _abortController: AbortController
): Promise<TreeNode> {
  console.log("replaceImagesInSectionWithAiMutating starting...", section.id);

  await setStockPhotoSearchKeywordsForImageControlsInASection(
    section,
    "mutate"
  );
  await setStockPhotoSearchResultsForImageControlsInASection(section, "mutate");
  await setImageControlsInSectionToStockPhotoSearchResults(section, "mutate");

  console.log("replaceImagesInSectionWithAiMutating done for", section.id);

  return section;
}
